export default __webpack_public_path__ + "static/media/11-1.ce8d677f.jpg";